import { useAssetFileQuery } from "@/hooks/assets";
import Skeleton from "@ingka/skeleton";
import { VideoHTMLAttributes } from "react";

type Props = {
  assetId: number;
  thumbnail?: boolean;
} & VideoHTMLAttributes<HTMLVideoElement>;

export const AuthenticatedVideo = ({ assetId, thumbnail, ...rest }: Props) => {
  const { data } = useAssetFileQuery(assetId, thumbnail);

  return data ? (
    <video controls src={data?.blobUrl} className="size-full object-contain" />
  ) : (
    <Skeleton className={rest.className} />
  );
};
